//Simple script to inline load a 3rd party script. Option to pass function once done.
export default loadScript = (url, callback, id) => {
    var script = document.createElement("script")
    script.type = "text/javascript";

    if(id){
        script.setAttribute('id',id);
    }

    if (script.readyState) { //IE
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else { //Others
        script.onload = function () {
            callback();
        };
    }

    script.src = url;
    document.querySelector("#js__body").appendChild(script);
}